<template>
    <div class="basic">

        <div class="form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
                     class="demo-ruleForm">
                <div class="item">
                    <div class="label">账号</div>
                    <div class="input">
                        <el-input v-model="ruleForm.mobile" placeholder="请输入昵称" readonly=""></el-input>
                    </div>
                    <div class="tips">账号不能更改，请修改绑定手机，即可更改登录账号！</div>
                </div>
                <div class="item">
                    <div class="label">昵称</div>
                    <el-form-item label="" prop="nickname">
                        <div class="input">

                            <el-input v-model="ruleForm.nickname" placeholder="请输入昵称"></el-input>

                        </div>
                    </el-form-item>
                </div>
                <div class="item">
                    <div class="label">个人简介</div>
                    <div class="input">
                        <el-form-item label="" prop="introduce">
                            <el-input type="textarea" :autosize="{ minRows: 4}" v-model="ruleForm.introduce" placeholder="这个人很懒，什么也没留下"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="item">
                    <div class="label">国家地区</div>
                    <div class="input">
                        <el-form-item label="" prop="country_id">
                            <el-select v-model="ruleForm.country_id" placeholder="请选择">
                                <el-option
                                        v-for="item in countryList"
                                        :key="item.id"
                                        :label="item.value"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="item">
                    <div class="label">所在省市</div>
                    <div class="input cities">
                        <el-form-item label="" prop="province_id">
                            <el-select v-model="ruleForm.province_id" placeholder="请选择"  @change="changeRegionProvince">
                                <el-option
                                        v-for="item in provinceList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" prop="city_id" class="city">
                            <el-select v-model="ruleForm.city_id" placeholder="请选择" @change="changeRegionCity">
                                <el-option
                                        v-for="item in cityList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" prop="district_id" class="city">
                            <el-select v-model="ruleForm.district_id" placeholder="请选择">
                                <el-option
                                        v-for="item in districtList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="item">
                    <div class="label">街道地址</div>
                    <el-form-item label="" prop="address">
                        <div class="input">

                            <el-input v-model="ruleForm.address" placeholder="请输入街道地址"></el-input>

                        </div>
                    </el-form-item>
                </div>
                <div class="btns">
                    <button @click="submit('ruleForm')" type="button">提交</button>
                </div>

            </el-form>
        </div>

        <div class="head_pic">
            <div class="label">头像</div>
            <div class="pic_bg">
                <div class="img">
                    <img :src="ruleForm.avatar" alt=""  v-if="ruleForm.avatar">
                    <img :src="imageUrl" alt=""  v-else>
                </div>
            </div>
            <div class="file_btn">
                <el-upload
                        :action="uploadAction"
                        :headers="myHeaders"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                        :show-file-list="false"
                        :file-list="fileList">
                    <button>更换图像</button>
                </el-upload>
            </div>


        </div>
    </div>
</template>

<script>
    import {getUserInfo,get_region_list,updateUser} from '@/api/api'
    import axios from 'axios';
    export default {
        name: "basicSet",
        data(){
            return{
                uploadAction:axios.defaults.baseURL+"/upload/image",
                myHeaders: {
                    authorization: "Bear "+localStorage.getItem("token")
                },
                ruleForm:{
                    nickname:'',
                    country_id:1,
                    provice_id:'',
                    city_id:'',
                    district_id:'',
                    address:'',
                    avatar:'1',
                },
                countryList: [{
                    id: 1,
                    value: '中国'
                }],
                provinceList: [],
                cityList: [],
                districtList: [],
                fileList:[],
                imageUrl:require('../../assets/images/home/user_pic_01.png'),
                rules: {
                    nickname: [{
                        required: true,
                        message: '请输入昵称',
                        trigger: 'blur'
                    }
                    ],
                    introduce: [{
                        required: true,
                        message: '请输入个人简介',
                        trigger: 'blur'
                    }
                    ],
                    province_id: [{
                        required: true,
                        message: '请选择省份',
                        trigger: 'change'
                    }
                    ],
                    city_id: [{
                        required: true,
                        message: '请选择城市',
                        trigger: 'change'
                    }
                    ],
                    district_id: [{
                        required: true,
                        message: '请选择区县',
                        trigger: 'change'
                    }
                    ],
                    address: [{
                        required: true,
                        message: '请输入地址',
                        trigger: 'blur'
                    }
                    ]

                }
            }
        },
        mounted() {
            this.get_user_info()
            get_region_list(0).then(resp=>{
                this.provinceList=resp
            })
        },
        methods:{
            submit(formName){
                this.$refs[formName].validate((valid) => {
                    console.log(valid)
                    if (valid) {
                        updateUser(this.ruleForm).then(resp=>{
                            if(resp.status==1){
                                //	localStorage.setItem("token",resp.token)
                                //this.$router.push('/');
                                this.$message.success(resp.msg)
                            }else{
                                this.$message.error(resp.msg);
                            }
                        }).catch(error=>console.log(error))
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            get_user_info(){
                getUserInfo().then(resp=>{

                    if(resp.province_id!=''){
                        this.changeRegionProvince(resp.province_id,1);
                        this.changeRegionCity(resp.city_id,1)
                    }
                    this.ruleForm=resp;
                })
            },
            changeRegionProvince(val,type=0) {
                get_region_list(val).then(res => {
                    if(type==0){
                        this.ruleForm["city_id"]=''
                        this.ruleForm["district_id"]=''
                    }
                    this.cityList = res

                })
            },

            changeRegionCity(val,type=0) {
                get_region_list(val).then(res => {
                    if(type==0){
                        this.ruleForm["district_id"]=''
                    }
                    this.districtList = res
                })
            },
            // 图片上传
            handleAvatarSuccess(res, file) {
                this.coverUrl = URL.createObjectURL(file.raw);
                this.ruleForm["avatar"]=res.data;
                this.fileList.push(res.data)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPng = file.type === 'image/png';
                if (!isJPG && !isPng) {
                    this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
                    return false
                }else{
                    return true
                }
            }
        }
    }
</script>

<style lang="less">
    .basic{
        padding: 30px 0 40px 15%;
        display: flex;
        flex-wrap: wrap;
        .form{
            width: 600px;
            .item{
                float: left;
            }
            .label{
                font-size: 18px;
                color: #fff;
                padding: 12px 0 15px 0;
            }
            .input{
                width: 600px;
                .el-input__inner{
                    background-color: rgba(45, 153, 255, 0.3);
                    border: 0;
                    border-radius: 0;
                    color: #fff;
                    font-size: 16px;
                }
                .el-textarea__inner{
                    background-color: rgba(45, 153, 255, 0.3);
                    border: 0;
                    border-radius: 0;
                    color: #fff;
                    font-size: 16px;
                }
                .el-select{
                    width: 295px;
                }
                .city{
                    margin-left: 10px;
                }
            }
            .cities{
                display: flex;
                .el-form-item{
                    width: 193px;
                }
                .el-select{
                    width: 193px;
                }
            }
            .tips{
                font-size: 14px;
                color: #858FA9;
                padding-top: 8px;
            }
            .btns{
                width: 410px;
                padding-top: 55px;
                display: flex;
                justify-content: space-between;
                margin: 0 auto;
                button{
                    width: 410px;
                    height: 48px;
                    line-height: 48px;
                    background: #2D99FF;
                    font-size: 18px;
                    font-weight: 400;
                    color: #fff;
                    border: 0;
                    border-radius: 0;
                    text-align: center;
                }
            }
        }
        .head_pic{
            padding-left: 15%;
            .label{
                font-size: 18px;
                color: #fff;
                padding: 12px 0 15px 0;
            }
            .pic_bg{
                width: 166px;
                height: 166px;
                background: url("../../assets/images/home/box.png");
                display: flex;
                justify-content: center;
                align-items: center;
                .img{
                    width: 144px;
                    height: 144px;
                    border-radius: 50%;
                    img{
                        width: 100%;
                        border-radius: 50%;
                    }
                }
            }
            .file_btn{
                margin-top: 24px;
                text-align: center;
                button{
                    width: 130px;
                    height: 40px;
                    border: 1px solid #2D99FF;
                    background-color: transparent;
                    font-size: 16px;
                    color: #fff;
                    position: relative;
                    padding-left: 35px;
                    cursor: pointer;
                    &:before{
                        content: '';
                        width: 16px;
                        height: 16px;
                        background: url("../../assets/images/home/upload.png") no-repeat;
                        background-size: cover;
                        position: absolute;
                        left: 23px;
                        top: 50%;
                        margin-top: -8px;
                    }
                }
            }
        }
    }
</style>
